module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customReports.title":"Custom Reports","customReports.subtitle":"All reports created here are visible to all users within the tenant.","customReports.failedToLoad":"There was an issue loading the custom reports."}}')
  delete Component.options._Ctor
}
